'use client';

import Script from 'next/script';
import {useEffect, useLayoutEffect, useState} from 'react';

const CookieBanner = () => {
    const [shouldLoadBanner, setShouldLoadBanner] = useState(false);

    useLayoutEffect(() => {
        window.dataLayer = window.dataLayer || [];

        const gtag = (...args: unknown[]) => {
            window.dataLayer?.push(args);
        };

        const initializeGtag = () => {
            gtag('consent', 'default', {
                ad_storage: 'denied',
                analytics_storage: 'denied',
                ad_user_data: 'denied',
                ad_personalization: 'denied',
                wait_for_update: 500,
            });

            gtag('set', 'ads_data_redaction', true);
            gtag('set', 'developer_id.dMmY1Mm', true);
        };

        initializeGtag();
    }, []);

    useEffect(() => {
        let timeoutId: NodeJS.Timeout;

        const loadBannerWithDelay = () => {
            timeoutId = setTimeout(() => setShouldLoadBanner(true), 3000);
        };

        if (document.readyState === 'complete') {
            loadBannerWithDelay();
        } else {
            window.addEventListener('load', loadBannerWithDelay);
        }

        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            window.removeEventListener('load', loadBannerWithDelay);
        };
    }, []);

    if (!shouldLoadBanner) {
        return null;
    }

    return (
        <Script
            type="text/javascript"
            src="//cdn.cookie-script.com/s/a8e6ad7ba1437949b1447ba7ba4b1d6c.js"
            strategy="lazyOnload"
        />
    );
};

export default CookieBanner;
